/**
 * 로그인 성공 로그용 브라우저 위치.
 * 권한 거부·타임아웃·비보안 origin 이어도 로그인을 막지 않는다.
 */

export const LOGIN_GEOLOCATION_TIMEOUT_MS = 3000;
export const LOGIN_GEOLOCATION_MAX_AGE_MS = 300_000;

export type LoginGeolocation = {
  latitude: number;
  longitude: number;
};

export const isValidLoginLatitude = (value: number): boolean =>
  Number.isFinite(value) && value >= -90 && value <= 90;

export const isValidLoginLongitude = (value: number): boolean =>
  Number.isFinite(value) && value >= -180 && value <= 180;

/** 한쪽만 있으면 서버가 둘 다 무시하므로 쌍이 아니면 null */
export const toLoginGeolocation = (
  latitude: unknown,
  longitude: unknown,
): LoginGeolocation | null => {
  if (typeof latitude !== 'number' || typeof longitude !== 'number') {
    return null;
  }
  if (!isValidLoginLatitude(latitude) || !isValidLoginLongitude(longitude)) {
    return null;
  }
  return { latitude, longitude };
};

export const getLoginGeolocation =
  async (): Promise<LoginGeolocation | null> => {
    if (typeof navigator === 'undefined' || !navigator.geolocation) {
      return null;
    }

    try {
      const position = await new Promise<GeolocationPosition | null>(
        (resolve) => {
          navigator.geolocation.getCurrentPosition(
            resolve,
            () => resolve(null),
            {
              timeout: LOGIN_GEOLOCATION_TIMEOUT_MS,
              maximumAge: LOGIN_GEOLOCATION_MAX_AGE_MS,
            },
          );
        },
      );
      return toLoginGeolocation(
        position?.coords.latitude,
        position?.coords.longitude,
      );
    } catch {
      return null;
    }
  };
